import request from '../../config/axiosConfig';
import {
  GET_LIST_FEATURES, GET_FEATURE_INFO, CREATE_FEATURE,
  UPDATE_FEATURE, DELETE_FEATURE, LIST_ACTIVE_FEATURES
} from '../../constants/apiEndPoint';

export const getListFeaturesRequest = async (data) => {
  const result = await request({ url: GET_LIST_FEATURES, method: 'POST', data });
  return result?.data.data;
};

export const getFeatureInfoRequest = async (data) => {
  const result = await request({ url: GET_FEATURE_INFO, method: 'POST', data });
  return result?.data.data;
};

export const createFeatureRequest = async (data) => {
  const result = await request({ url: CREATE_FEATURE, method: 'POST', data });
  return result?.data;
};

export const updateFeatureRequest = async (data) => {
  const result = await request({ url: UPDATE_FEATURE, method: 'POST', data });
  return result?.data;
};

export const deleteFeatureRequest = async (data) => {
  const result = await request({ url: DELETE_FEATURE, method: 'POST', data });
  return result?.data;
};

export const listActiveFeaturesRequest = async (data) => {
  const result = await request({ url: LIST_ACTIVE_FEATURES, method: 'POST', data });
  return result?.data.data;
};
